import type { Filters } from "~/js/interfaces/locations";
import { isLocationAreaFilterActive } from "~/js/composables/location-area";

type LocationFilterCountRule = {
	/** Number of options shown as checked in the filters panel for this group. */
	count: (filters: Filters) => number;
};

const countCheckedBooleans = (...values: (boolean | null | undefined)[]): number =>
	values.filter((value) => value === true).length;

/**
 * Each rule mirrors one filters-panel section. Add a rule when introducing a new group.
 * Counts checked options only (same semantics as FilterLocationsPanel checkboxes).
 */
const locationFilterCountRules: LocationFilterCountRule[] = [
	{
		count: (filters) =>
			countCheckedBooleans(filters.availableNow?.value, filters.availableSoon?.value),
	},
	{ count: (filters) => filters.type.values.length },
	{
		count: (filters) =>
			isLocationAreaFilterActive(filters.area.min, filters.area.max) ? 1 : 0,
	},
];

/** Total checked location filter options for the filters badge. */
export const countActiveLocationFilters = (filters: Filters): number =>
	locationFilterCountRules.reduce((total, rule) => total + rule.count(filters), 0);
